import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const InvoiceLink = styled.a`
  color: ${({ theme }) => theme.colors.primary.actionDefault};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`;

export const V2Title = styled.div`
  font-size: 32px;
  padding: 32px 0 8px 0;
  font-family: "Gotham";
  font-weight: 500;
  color: ${({ theme }) => theme.colors.greyscale.gray40};
`;
